import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-explore-four',
  templateUrl: './breadcrumb-explore-four.component.html',
  styleUrls: ['./breadcrumb-explore-four.component.scss']
})
export class BreadcrumbExploreFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
